import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import { getCurrentInterval } from '../../../utils';

const formatTrends = ({
  data,
  answers,
  valueDirection,
  maxValue,
  minValue,
  displayIntervals,
  type,
  scoringsIndex,
}) => {
  if (_isEmpty(data)) return null;

  const scorings = data.map((item, index) => {
    const componentScoring =
      type === 'overall' ? item.overallScoring : item.scoring[scoringsIndex];
    let formattedScore = componentScoring;
    if (type === 'overall') {
      if (valueDirection === 'higherBetter') {
        formattedScore = Math.round(
          (componentScoring / (maxValue - minValue)) * 100,
        );
      } else {
        formattedScore = Math.round(
          ((maxValue - minValue - componentScoring) / maxValue) * 100,
        );
      }
    }
    const [interval] = getCurrentInterval(displayIntervals, formattedScore);

    return {
      score: formattedScore,
      date: answers[index].date,
      timestamp: answers[index].timestamp,
      color: _get(interval, 'color'),
    };
  });

  return scorings;
};

export default formatTrends;
